export const socialsData = {
    github: 'https://github.com/sirshikher',
    facebook: '',
    linkedIn: 'https://www.linkedin.com/in/shikher-mishra-540075140/',
    instagram: '',
    codepen: '',
    twitter: '',
    reddit: '',
    blogger: '',
    medium: 'https://sirshikher.medium.com/',
    stackOverflow: '',
    gitlab: '',
    youtube: ''
}